import { Url } from '../../../shared/constant/url.constant';

/**
 * Route utilisées pour les domain.
 */
export namespace DomainLink {
  export const data = {
    title: 'Domains',
    sub: {
      lister: 'Lister',
      ajouter: 'Ajouter',
      ajout: {
        title: 'Ajout d\'un Domain'
      },
      liste: 'Liste',
      list: {
        title: 'Liste des Domains'
      }
    }

  }
  export const url = {
    FEES: {
      FEES_: 'domain',
      LIST: 'liste',
      ADD: 'add'
    }
  };

  export const urlFull = {
    FEES: {
      ADD: DomainLink.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(DomainLink.url.FEES.ADD),
      LIST: DomainLink.url.FEES.FEES_
        .concat(Url.SLASH_ROUTE).concat(DomainLink.url.FEES.LIST),
    }
  };
}
